import { apply as AP, array as AR, either as E, eitherT as ET, function as FN, io as IO, ioEither as IOE, nonEmptyArray as NEA, option as O, readonlyArray as RAR, readonlyNonEmptyArray as NEAR, task as TA, taskEither as TE, } from "fp-ts";
const { pipe } = FN;
export { pipe, FN, AP, AR, E, ET, IO, IOE, NEA, O, RAR, NEAR, TA, TE };
export const unwrap = (either) => {
    if (E.isLeft(either)) {
        throw either.left;
    }
    return either.right;
};
export const unwrapTask = async (operation) => unwrap(await operation());
export const applyEffect = (op) => (input) => {
    op(input);
    return input;
};
/**
 * This is like map except it maintains the passthrough value. It is only there
 * to have a side effect, not change the response.
 */
export const effect = (op) => (task) => pipe(task, TE.map(applyEffect(op)));
export const effectLeft = (op) => (task) => pipe(task, TE.mapLeft(applyEffect(op)));
/**
 * This is like map except it maintains the passthrough value. It is only there
 * to have a side effect, not change the response.
 */
export const bieffect = (opl, opr) => (task) => pipe(task, TE.bimap(applyEffect(opl), applyEffect(opr)));
/**
 * This is a comically simple wrapper for creating a TaskEither out of a function
 * that returns a Promise. It also assumes the `left` is of type `Error`.
 */
export const fromAsync = (fn) => TE.tryCatch(fn, err => err);
export const squish = (e) => (E.isLeft(e) ? e.left : e.right);
//# sourceMappingURL=fp.js.map